// extracted by mini-css-extract-plugin
export default {"menuListSwitchContainer":"MenuListSelectAll_menuListSwitchContainer__DjvcI","selectDeselectTitle":"MenuListSelectAll_selectDeselectTitle__Oaznm"};